$(document).ready(function() {
    console.log('filter');
    //$('.filter-group').toggleClass('show');
    $('.filter-group h4').on('click', function(e) {
        $(this).parent().toggleClass("hide-content");
        e.preventDefault();
      });
      $('.pt-mobile-header').on('click', function() {
        //console.log($(this).parent().parent());
        $(this).parent().toggleClass("show-filter-group");
      });
});